
export function formatUrl(str) {
  return str.trim()
            .replace(/[^a-zA-Z ]/g, '')
            .replace(/\s+/g, '-')
            .toLowerCase()
}
